import { useQuery } from 'react-query';

import { QueryEntity } from '../../types';
import { SeatBasedUsageResponse } from '../../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useFetchSeatBasedUsage = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<SeatBasedUsageResponse | null>(
    [QueryEntity.SeatBasedUsage],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/org/usage-data/seat-usage`, fetchConfigGET);
      if (!res.ok) throw new Error('Failed to fetch seat-based usage');
      return await res.json();
    },
    { refetchOnWindowFocus: false },
  );
};
